import { CSSProperties } from 'react'
import { Wrapper } from './TextArea.styles'

type TextAreaProps = {
  value: string
  onChange: (e: React.FormEvent<HTMLTextAreaElement>) => void
  onBlur?: (e: React.FormEvent<HTMLTextAreaElement>) => void
  onFocus?: (e: React.FormEvent<HTMLTextAreaElement>) => void
  name?: string
  style?: CSSProperties
  placeholder?: string
  disabled?: boolean
  error?: boolean
  required?: boolean
  maxlength?: number
  minLength?: number
  type?: 'password' | 'text'
}

const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  style,
  disabled,
  minLength,
  maxlength,
  name = '',
  required = false,
  error = false,
}) => {
  return (
    <Wrapper
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      style={style}
      placeholder={placeholder}
      disabled={disabled}
      maxLength={maxlength}
      minLength={minLength}
      data-testid={`textarea-${name}`}
      required={required}
      error={error}
    />
  )
}

export default TextArea
